'use client';
import { RichTextContent as SharedRichTextContent } from '@launchstore/shared-puck';
import type { RichTextContentProps } from '@launchstore/shared-puck';
export const RichTextContent: any = SharedRichTextContent;
export type { RichTextContentProps };
export default RichTextContent;
